export default __webpack_public_path__ + "static/dmytro-hrab-8c6060ef146d3eb8d6545ccd46d00797.png";